import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { CxC } from './cxc';
import { cxcRetencion } from './cxcRetencion';

@Injectable({
  providedIn: 'root'
})
export class RetencionVentasService {

  
  
  constructor(private http: HttpClient) { }

  setActulizar(lista: cxcRetencion[]){
    console.log(lista);
    return this.http.put<string>(environment.apiUrl+"/actulizarRetencionVentas/",lista);
  }
  
  

  getListaRetencionVenta(id: string) {  
    
    return this.http.get<cxcRetencion[]>(environment.apiUrl+"/listaRetencionesVenta/?idEmisor=" + id);  
  }  
 
}
